import React from "react";
import { Divider, Header, Container, Segment } from "semantic-ui-react";
import axios from "axios";
import ProfileEditForm from "./ProfileEditForm";
import ChangePasswordForm from "./ChangePasswordForm";
import { DealerDocuments } from "./DealerDocuments";

class Profile extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      data: {
        name: "",
        address_1: "",
        address_2: "",
        city: "",
        country: "",
        email: "",
        marketing_url: "",
        id: null,
        phone: "",
        state: "",
        zip: "",
        time_zone: "",
      },
      centralizedBookkeeping: null,
    };

    this.handleEditChange = this.handleEditChange.bind(this);
  }

  componentDidMount() {
    axios
      .get("/profile/")
      .then((res) => {
        this.setState({
          data: res.data,
          loading: false,
          centralizedBookkeeping: res.data.centralized_bookkeeping,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  }

  handleEditChange(e) {
    const data = { ...this.state.data };
    data[e.target.name] = e.target.value;
    this.setState({ data });
  }

  render() {
    const { centralizedBookkeeping, loading } = this.state;

    const {
      name,
      address_1,
      address_2,
      city,
      country,
      email,
      id,
      phone,
      state,
      zip,
      time_zone,
    } = this.state.data;

    return (
      <Container>
        <Segment padded loading={loading}>
          <Header
            content="Profile"
            as="h1"
            subheader="* denotes required field"
            dividing
          />
          <Divider hidden />
          <ProfileEditForm
            address_1={address_1}
            address_2={address_2}
            city={city}
            name={name}
            country={country}
            email={email}
            id={id}
            phone={phone}
            state={state}
            zip={zip}
            time_zone={time_zone}
            handleEditChange={this.handleEditChange}
          />
        </Segment>
        {!centralizedBookkeeping && (
          <Segment padded>
            <DealerDocuments />
          </Segment>
        )}
        <Segment padded>
          <ChangePasswordForm />
        </Segment>
      </Container>
    );
  }
}

export default Profile;
